import { checkoutUrl } from '../data/landing';

export function isValidCheckoutUrl(value: string = checkoutUrl) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}
